import { AxiosResponseHeaders } from 'axios';
import { SweepOrdersResponseDTO } from '../entities';

const sweepOrderDetailsDTOToSweepOrderDetailsAdapter = (
  data: SweepOrdersResponseDTO,
  headers?: AxiosResponseHeaders,
) => {
  if (!data.body) {
    throw new Error('Error');
  }

  return data.body;
};

export { sweepOrderDetailsDTOToSweepOrderDetailsAdapter };
